import axios from '../api/axios';

// ** CarHouse Invoices **

export async function getCarHouseInvoices(carHouseId) {
  const response = await axios.get(`/carHouses/${carHouseId}/invoices`);
  return response.data;
}

export async function editCarHouseInvoices(carHouseId, invoiceId, body) {
  const response = await axios.patch(
    `/carHouses/${carHouseId}/invoices/${invoiceId}/pay`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function getCarHouseInvoicesItems(
  carHouseId,
  invoiceId,
  pagination,
  format='json'
) {

  const headers = {
    page: pagination.page,
    limit: pagination.total,
  };

  const options = {
    headers: headers,
  };

  const response = await axios.get(
    `/carHouses/${carHouseId}/invoices/${invoiceId}/items?format=${format}`,  options
  );
  return response.data;
}

// ** User Invoices **

export async function getUserInvoices(userId) {
  const response = await axios.get(`/users/${userId}/invoices`);
  return response.data;
}

export async function editUserInvoices(userId, invoiceId, body) {
  const response = await axios.patch(
    `/users/${userId}/invoices/${invoiceId}/pay`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function getUserInvoicesItems(userId, invoiceId, pagination, format = 'json') {
  const headers = {
    page: pagination.page,
    limit: pagination.limit,
  };

  const options = {
    headers: headers,
  };

  try {
    const response = await axios.get(`/users/${userId}/invoices/${invoiceId}/items?format=${format}`, options);
    return response.data;
  } catch (error) {
    throw error;
  }
}